import { apiRequest } from '../../api-client';

export interface SubscriptionInfo {
  id: string;
  product_slug: string;
  purchase_state: string;
  start_date: string;
  end_date: string;
  current_period_start?: string;
  current_period_end?: string;
  // Optional; present whenever billing includes them (typically enterprise
  // membership subscriptions). May be absent on older billing runtimes.
  access_type?: string;
  entitlements?: Record<string, boolean>;
}

export interface EnterpriseInfo {
  id: string | null;
  name: string | null;
  isAdmin: boolean;
  subscriptionList: SubscriptionInfo[];
  paymentType: string;
}

export interface UserInfoResponse {
  id: string;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  emailVerified: boolean;
  enabled: boolean;
  createDate: string;
  enterprises: EnterpriseInfo[];
  billingUser: boolean;
  stripeId: string | null;
  subscriptionList: SubscriptionInfo[] | null;
  paymentType: string;
  isEnterpriseAdmin: boolean;
}

export interface GetUserInfoParams {
  token: string;
  enterpriseId: string;
  userId: string;
}

/**
 * Fetch full user info for an enterprise member.
 * GET /api-internal/enterprise/:enterprise_id/users/:user_id/info
 */
export function getEnterpriseUserInfo({
  token,
  enterpriseId,
  userId
}: GetUserInfoParams): Promise<UserInfoResponse> {
  return apiRequest<UserInfoResponse>({
    method: 'GET',
    endpoint: `/api-internal/enterprise/${enterpriseId}/users/${userId}/info`,
    token
  });
}
